import { useCallback, useEffect, useState } from 'react';
import { FetchSoldProductsSearchProps, ListSoldProductsByEvent, SoldProductByEvent } from 'lib/models/listSoldProducts';

function useListSoldProductsByEvent(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [data, setData] = useState<SoldProductByEvent[]>([]);

	const refetch = useCallback(
		async (props?: FetchSoldProductsSearchProps) => {
			setLoading(true);
			const response = await ListSoldProductsByEvent(props || searchProps);
			setData(response);
			setLoading(false);
		},
		[searchProps]
	);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, data, refetch };
}

export default useListSoldProductsByEvent;
